// extracted by mini-css-extract-plugin
module.exports = {"nomineesContainer":"Nominees_nomineesContainer__3FVqS","title":"Nominees_title__bUson"};